module.exports = __webpack_public_path__ + "static/media/lionsrun.4aa5aa3a.svg";